import { toast } from "sonner";
import type { AppDispatch } from "..";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { makeRequest } from "@/utils/makeRequest";

import {
  getSettingsRequest,
  getSettingsSuccess,
  getSettingsFailure,
  updateSetting,
} from "../slices/settingsSlice";

export const fetchSettings = () => async (dispatch: AppDispatch) => {
  dispatch(getSettingsRequest());

  try {
    const res = await makeRequest.get("/setting/me");

    dispatch(getSettingsSuccess(res.data));
  } catch (error) {
    dispatch(getSettingsFailure(getErrorMessage(error)));

    toast.error(getErrorMessage(error));
  }
};

export const persistSettings =
  (payload: any) => async (dispatch: AppDispatch) => {
    try {
      const res = await makeRequest.put("/setting/me", payload);

      dispatch(updateSetting(res.data));

      toast.success("Settings updated");

      return res.data;
    } catch (error) {
      toast.error(getErrorMessage(error));
      throw error;
    }
  };
